import { Component, OnDestroy, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Observable, combineLatest, of, Subscription } from 'rxjs';
import { map, mergeMap } from "rxjs/operators";
import { ValidatorFn, AbstractControl, FormGroup, FormControl } from "@angular/forms";
import { DwConfigServiceToken, DwConfigService, DwSecurityUserService, DwComponent, DwComponentType, DwMetaDataService,
         DwSectionBaseComponent, DwExpressionService, DwUiConfigRegistryService, DwUIMetaDataConfig,
         DwMetaDataFormApi, DwMetaDataRoutingService, DwMenuActionType, DwModalConfig,
         DwUIMetaDataConfigToken, DwMetaDataServiceToken, DwMetaDataFormStateService, DwFormActionInterceptor, 
         DwEventService, DwGridActionResult} 
        from '@devwareapps/devware-cap';
import { AviatorUser } from '../../../shared/models/aviator-user.model';
import { Inject, Injectable } from "@angular/core";
import { AppMetaDataItemNames, SubscriptionTierBenefitEntity, SubscriptionTierEntity, 
         RoSchoolSubscriptionEntity, SubscriptionEntity, SubscriptionStatusAllItems,
         ProcessorConfigEntity, PaymentMethodEntity  } 
        from '../../../../meta-data/app-meta-data.service';
import { PaymentsRepositoryService } from "src/app/features/payments/services/payments-repository.service";
import { HttpClient } from "@angular/common/http";
import { CreateCustomerResult } from "src/app/features/payments/models/create-customer-result.model";
import { DateTimeUtilService } from '../../../shared/util/date-time-util.service';
import * as moment from "moment";
import { environment } from 'src/environments/environment';
import { EnvironmentConfigItem } from 'src/environments/models/environment-config.model';
import { AppPermissions } from 'src/app/meta-data/app-permissions.enum';
import { AdminManagerService } from 'src/app/features/admin/services/admin-manager.service';
import { DiscountView, DiscountCodeComponent } from '../discount-code/discount-code.component';
import { PricingDiscountResult } from '../../models/pricing-discount-result.model';
import { PaymentsPricingRepositoryService } from '../../services/payments-pricing-repository.service';
import { SubscriptionPriceRequest } from '../../models/subscription-price-request.model';
import { SubscriptionPriceResult } from '../../models/subscription-price-result.model';
import { PaymentParty } from '../../models/payment-party.enum';

@DwComponent({
    key: 'change-school-subscription',
    name: 'Change School Subscription',
    componentType: DwComponentType.formSection,
    isGlobal: false,
    parentItemName: AppMetaDataItemNames.FlightSchool,
})
@Component({
    selector: 'change-school-subscription',
    templateUrl: './change-school-subscription.component.html',
    styleUrls: ['./change-school-subscription.component.scss']
})
export class ChangeSchoolSubscriptionComponent extends DwSectionBaseComponent 
    implements OnInit, OnDestroy {
    subscritpionCardClass: string;

    constructor(
        dwExpressionService: DwExpressionService,
        protected dwUiConfigRegistryService: DwUiConfigRegistryService,
        @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
        @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
        private dwFormStateService: DwMetaDataFormStateService,
        private dwSecurityUserService: DwSecurityUserService,
        private dwEventService: DwEventService,
        private dwMetaDataRoutingService: DwMetaDataRoutingService,
        private paymentsRepoSvc: PaymentsRepositoryService,
        private paymentPricingRespository: PaymentsPricingRepositoryService,
        private dateTimeUtilService: DateTimeUtilService,
        private adminManagerService: AdminManagerService,
        private http: HttpClient,
        @Inject(DwConfigServiceToken) private configService: DwConfigService) 
    {
        super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
        this.paymentsApi = `${configService.coreConfig.apiRoot}/aviator-online/Payments`;
        this.formApi = this.dwFormStateService.state.formApi;
    }

    formApi: DwMetaDataFormApi;
    subscriptions: Subscription[] = [];
    aviatorUser: AviatorUser;
    paymentsApi: string;
    isFSAdmin: boolean = false;
    benefits: SubscriptionTierBenefitEntity[] = [];
    currentSub : RoSchoolSubscriptionEntity;
    newSub : SubscriptionEntity;
    prevSub : SubscriptionEntity;
    tiers: SubscriptionTierEntity[] = [];
    test : boolean = false;
    subWidth : string = '';
    subHeight : string = '';
    benefitSize : string = '1.6em';
    discountCode: string = undefined;
    @Input() discountResult: PricingDiscountResult;
    methods: PaymentMethodEntity[] = [];
    defaultMethod: PaymentMethodEntity; 

    setupComponentComplete(){ 
        this.test = this.isTest();
        this.aviatorUser = this.adminManagerService.getAviatorUser();

        this.isFSAdmin = this.aviatorUser?.user.Permissions.indexOf(AppPermissions.flightSchoolAdmin) > -1;

        this.paymentsRepoSvc.getSubriptionTiers()
            .subscribe(tiers => {
                this.tiers = tiers;
                this.setupTiers();

            });
        this.getCurrentSub(); 
        this.updateMethods();
    }  

    private setupTiers() {
        const count : number = this.tiers.length;
        this.subWidth = `${Math.round(95/count)}%`;      
        this.subscritpionCardClass = count <= 4 ?  `subscription-card-${count}` : 'subscription-card-4';     
        this.subHeight = count == 3 ? '330px' : count == 4 ? '320px' : '310px';              
        this.benefitSize = count == 3 ? '1.4em' : count == 4 ? '1.4em' : '1.2em';            
    }

    getDefaultPayment() : PaymentMethodEntity{
        return this.methods.find(p => p.IsDefault);
    }
    
    updateMethods(){
        this.paymentsRepoSvc.getProcessorConfig(PaymentParty.FlightSchool)
            .subscribe(result => {
                if (result.ProcessorConfig != undefined)
                    this.paymentsRepoSvc
                        .getPaymentMethodsForConfig(result.ProcessorConfig)
                        .subscribe(pms => {
                            this.methods = pms;
                            this.defaultMethod = this.getDefaultPayment();
            });
        });
    }

    ngOnInit() {
        if (!this.isFSAdmin)
            return;
    }

   

    pricing: SubscriptionPriceResult;
    cost(id: number) : { original:string, discounted:string, cost: number, discountedCost: number} {
        const cost = this.tiers.find(t => t.SubscriptionTierId == id)?.PlatformMonthlyCost;
        let discountedCost = cost;
        const free = 'FREE'
        const original : string = cost > 0 ? `$${cost}` : free;
        let discounted : string = undefined;
        if (this.pricing != undefined && this.pricing.IsSuccess == true){
            const discount = this.pricing.TierPricing
                                 .find(t => t.SubscriptionTier.SubscriptionTierId == id);
            if (discount) {
                discountedCost = cost - discount.DiscountAmount;        
                discounted = original != free && discount?.DiscountAmount > 0 ?
                                `$${(discountedCost)}` : undefined; 
            }          
        }
        return { original, discounted, cost: cost ?? 0, discountedCost:discountedCost  };
    }

    getPriceRequest(): SubscriptionPriceRequest{
        const pricingRequest: SubscriptionPriceRequest = {
            DiscountCode: this.discountCode
        };
        return pricingRequest;
    }

    updateDiscounts() {
        this.paymentPricingRespository.getSubscriptionPricing(this.getPriceRequest())
          .subscribe(pricingResult => {
            this.pricing = pricingResult;
            this.discountResult = pricingResult.TierPricing
                                        .find(t => t.SubscriptionTier.SubscriptionTierId == this.currentSub?.SubscriptionTierId)?.DiscountResult;
            this.saveCode();
          });
    }
    saveCode(){
        const currentCode = this.currentSub?.Subscription?.Discount?.DiscountCode ?? "";
        const targetCode = this.discountCode ?? "";
        if (currentCode != targetCode){
            const url = `${this.paymentsApi}/apply-discount-sub/${this.currentSub?.SubscriptionId}/${targetCode}`;
            this.http.get(url)
                .subscribe(r => {
                });
        }
    }    
    onDiscountCodeChange(e:string){ 
    }

    onDiscountCodeApplied(e:string){ 
        this.discountCode = e;
        this.updateDiscounts();
    }

    onDiscountCodeCleared(){ 
        this.discountCode = '';
        this.updateDiscounts();
        this.saveCode();
    }
    
    cannotSwitch(tier: SubscriptionTierEntity){
        return !this.canSwitchBack(tier) && !this.canSwitchTo(tier);
    }
    canSwitchBack(tier: SubscriptionTierEntity){
        const tierId = tier.SubscriptionTierId;
        if (this.currentSub == undefined) return false;
        const hasPrevious = this.prevSub != undefined && this.currentSub?.SubscriptionTierId == tierId;
        const isPending = this.newSub != undefined && this.currentSub?.SubscriptionTierId == tierId;
        return hasPrevious || isPending;
    }
    canSwitchTo(tier: SubscriptionTierEntity){
        const tierId = tier.SubscriptionTierId;
        if (this.currentSub == undefined) return false;
        const untouched = this.newSub?.SubscriptionTierId != tierId &&
                          this.prevSub?.SubscriptionTierId != tierId &&
                          this.currentSub?.SubscriptionTierId != tierId;
        const noPendingNotCurrent = this.newSub == undefined && untouched;
        const notPending = this.newSub != undefined && untouched;
        const notPrevious = this.prevSub != undefined && untouched;
        return noPendingNotCurrent || notPending || notPrevious;
    }
    getCurrentSub(){
        this.paymentsRepoSvc.getRoSchoolSub(this.aviatorUser.FlightSchoolId)
            .subscribe(s => this.assignCurrent(s));
    }
    validateNeedPayment(tierId: number, switchBack: boolean): Observable<DwGridActionResult> {
        let result: DwGridActionResult = { cancelled: false, success: true };

        const hasCost = this.cost(tierId)?.discountedCost > 0;
        const noPaymentMethod = this.defaultMethod == undefined
        if (hasCost && noPaymentMethod && !switchBack){
            const modalOptions: Partial<DwModalConfig> = {
                title: 'Add New Card'
            }	
            return this.dwMetaDataRoutingService.openAddEditViewModal(
                        DwMenuActionType.add, AppMetaDataItemNames.PaymentMethod, null, null, null, 
                        'school-add-card', modalOptions, true)
            .pipe(map(modalResult => {
                result.success = !modalResult.cancelled;
                result.cancelled = modalResult.cancelled;
                result.dataActionResult = null;
                result.refreshData = !modalResult.cancelled;
                if (result.success)
                    this.updateMethods();
                return result;
            }));        
        }
        else
            return of(result);
    }
    CHANGE_VIEW = 'DISCOUNT-VIEW-CHANGE';
    assignCurrent(s: RoSchoolSubscriptionEntity){
        this.currentSub = s;
        if (s.Subscription?.Discount?.DiscountCode?.length > 0)
            this.onDiscountCodeApplied(s.Subscription?.Discount?.DiscountCode);
        this.newSub = s.PendingSubscription;
        this.prevSub = s.PreviousSubscription;
        this.saveCode();
        this.updateDiscounts();
    }
    switchTo(tier: SubscriptionTierEntity){
        const tierId = tier.SubscriptionTierId;
        const switchBack : boolean = this.canSwitchBack(tier);
        this.validateNeedPayment(tierId, switchBack)
            .subscribe((result) => {
                const fsId = this.aviatorUser.FlightSchoolId;
                if (result.cancelled)
                    return;
                if (switchBack)
                    this.paymentsRepoSvc.undoPendingSub(fsId)
                        .subscribe(s => this.assignCurrent(s));
                else{
                    //1. Look for TRUE prior pending
                    this.paymentsRepoSvc.getPriorPendingSub(fsId)
                        .subscribe(prior =>{
                            const today = moment(new Date());
                            const yesterday = today.add(-1,'days');
        
                            //In a switchTo, treat outgoing as if still current
                            const cur = this.currentSub.PreviousSubscription ??
                                        this.currentSub.Subscription;
        
                            //In a switchTo, treat incoming as if still the pending
                            const pending = (this.currentSub.PreviousSubscription != undefined 
                                                ? this.currentSub.Subscription : null) ??
                                            this.currentSub.PendingSubscription ?? prior ?? 
                                            {   _itemName: AppMetaDataItemNames.Subscription,
                                                FlightSchoolId: this.aviatorUser.FlightSchoolId };
        
                            //2. Set current end date to yesterday and Status to Inactive
                            cur.SubscriptionStatusId = SubscriptionStatusAllItems.Inactive;
                            cur.EffectiveEndDate = yesterday.utc().format('YYYY-MM-DD');
        
                            //3. Create New (if applicable) & set to new tier selected
                            pending.EffectiveEndDate = null;
                            pending.EffectiveStartDate = today.utc().format('YYYY-MM-DD');
                            pending.SubscriptionTierId = tierId;
                            pending.Pending = true;
                            pending.SubscriptionStatusId = SubscriptionStatusAllItems.Active;
                            this.paymentsRepoSvc.switchSubscriptionTo(this.currentSub, pending)
                                .subscribe(subs => {
                                    this.getCurrentSub();
                                });
                
                        });
                }
            });
    }
    benefitsFor(tier: number) {
        return this.benefits.filter(b => b.SubscriptionTierId == tier);
    }
    tier(id: number) : SubscriptionTierEntity {
        return this.tiers.find(t => t.SubscriptionTierId == id);
    }
    ngOnDestroy(): void {
        for (let subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }

    isTest() : boolean {
        const environments : EnvironmentConfigItem[] = (environment as any).environments;
        if (environments) {
            const environmentKey = (environment as any).environmentKey;
            return environmentKey == 'Test' || environmentKey == 'TestLocal';
        }
        return false;
    }
}